import React from "react";

import Dialog from "material-ui/Dialog";
import DialogTitle from "material-ui/Dialog/DialogTitle";
import DialogContent from "material-ui/Dialog/DialogContent";
import DialogActions from "material-ui/Dialog/DialogActions";
import withStyles from "material-ui/styles/withStyles";
import CallIcon from "@material-ui/icons/Call";

import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import Button from "components/CustomButtons/Button.jsx";

import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";

class DetailedReportView extends React.Component{
    
    render(){
      const data = this.props["data"];
      const dataJson = JSON.parse(data.dataJson);

      const pin = dataJson["pin"];
      const form = dataJson["conf"];
      const reportedBy = data.user.username;
      const reportedOn = data.createdAt;
      const description = data.description;
      const project = data.pin1.project.name;

      const uiOrder = form["ui:order"];
      const callerData = dataJson["caller"];
      const receiverData = dataJson["receiver"];
      const callerProps = form["properties"]["caller_props"]["properties"];
      const receiverProps = form["properties"]["receiver_props"]["properties"];

      let callerList = [];
      let receiverList = [];

      for (const key in uiOrder["caller_props"]["ui:order"]) {
        let uiKey = uiOrder["caller_props"]["ui:order"][key];
        let itm = null;

        if (uiKey["key"])
          uiKey = uiKey["key"];

        if (callerProps[uiKey]['enum']) {
          for (const cpKey in callerProps[uiKey]['enum']) {
            if (callerProps[uiKey]['enum'][cpKey] == callerData[uiKey]) {
              itm = (
                <ItemGrid>
                    <p><b>{`${callerProps[uiKey]['title']}:`}</b> {`${callerProps[uiKey]['enumNames'][cpKey] || "None"}`}</p>
                </ItemGrid>
              );
            }
          }
        }
        else {
          itm = (
            <ItemGrid>
                <p><b>{`${callerProps[uiKey]['title']}:`}</b> {`${callerData[uiKey] || "None"}`}</p>
            </ItemGrid>
          );
        }

        callerList.push(itm);
      }

      let speakerItm1 = (
        <ItemGrid>
          <p><b>{'Speaker ID'}</b> {dataJson.caller_speakerid}</p>
        </ItemGrid>
      )

      let deviceItm1 = (
        <ItemGrid>
          <p><b>{'Device ID'}</b> {dataJson.caller_deviceid}</p>
        </ItemGrid>
      )

      callerList.push(speakerItm1);
      callerList.push(deviceItm1);

      for (const key in uiOrder["receiver_props"]["ui:order"]) {
        let uiKey = uiOrder["receiver_props"]["ui:order"][key];
        let itm = null;

        if (uiKey["key"])
          uiKey = uiKey["key"];
        
        if (receiverProps[uiKey]['enum']) {
          for (const cpKey in receiverProps[uiKey]['enum']) {
            if (receiverProps[uiKey]['enum'][cpKey] == receiverData[uiKey]) {
              itm = (
                <ItemGrid>
                    <p><b>{`${receiverProps[uiKey]['title']}:`}</b> {`${receiverProps[uiKey]['enumNames'][cpKey] || "None"}`}</p>
                </ItemGrid>
              );
            }
          }
        }
        else {
          itm = (
            <ItemGrid>
                <p><b>{`${receiverProps[uiKey]['title']}:`}</b> {`${receiverData[uiKey] || "None"}`}</p>
            </ItemGrid>
          );
        }

        receiverList.push(itm);
      }

      let speakerItm2 = (
        <ItemGrid>
          <p><b>{'Speaker ID'}</b> {dataJson.receiver_speakerid}</p>
        </ItemGrid>
      )

      let deviceItm2 = (
        <ItemGrid>
          <p><b>{'Device ID'}</b> {dataJson.receiver_deviceid}</p>
        </ItemGrid>
      )

      receiverList.push(speakerItm2);
      receiverList.push(deviceItm2);

      const { classes } = this.props;

        return (
          <Dialog
            open={true}
            onClose={() => this.props.onClose()}
            scroll={'paper'}
            aria-labelledby="scroll-dialog-title"
            classes={{
              paper: classes.modal
            }}
            keepMounted
            aria-describedby="classic-modal-slide-description"
          >
          <DialogTitle id="scroll-dialog-title"
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader + " " + classes.center}>
              <h4>Report Information</h4>
          </DialogTitle>
            <DialogContent 
              id="classic-modal-slide-description"
              className={classes.modalBody}>
                <GridContainer style={{display: "flex"}}>
                    <ItemGrid xs={12} sm={12}>
                      <h5>Reported By</h5>
                      <p>{reportedBy}</p>
                    </ItemGrid>

                    <ItemGrid xs={12} sm={12}>
                      <h5>Reported On</h5>
                      <p>{reportedOn}</p>
                    </ItemGrid>

                    <ItemGrid xs={12} sm={12}>
                      <h5>Project</h5>
                      <p>{project}</p>
                    </ItemGrid>

                    <ItemGrid xs={12} sm={12}>
                      <h5>Description</h5>
                      <p>{description}</p>
                    </ItemGrid>

                    <ItemGrid xs={12} sm={12}>
                      <h5>Pin</h5>
                      <p>{pin}</p>
                    </ItemGrid>

                    <ItemGrid xs={12} sm={6}>
                      <h5>Caller</h5>
                      {callerList}
                    </ItemGrid>

                    <ItemGrid xs={12} sm={6}>
                      <h5>Receiver</h5>
                      {receiverList}
                    </ItemGrid>
                  </GridContainer>
            </DialogContent>
            <DialogActions className={
                            classes.modalFooter +
                            " " +
                            classes.modalFooterCenter
                          }>
                            
              <Button 
                onClick={() => this.props.onClose()} 
                color="defaultNoBackground">
                Done
              </Button>
            </DialogActions>
          </Dialog>
        );
    }
}

export default withStyles(notificationsStyle)(DetailedReportView);


// WEBPACK FOOTER //
// ./src/views/reports/components/DetailedReportView.js